{
  "pages_editor.placeholder": "Yazmak için yazın, komutlar için '/' tuşuna basın",
  "pages_editor.commands": "Bloklar ve kayıtlar",
  "pages_editor.insert_below": "Aşağıya blok ekle",
  "pages_editor.drag_handle": "Taşımak için sürükleyin veya blok işlemlerini açın",
  "pages_editor.turn_into": "Şuna dönüştür",
  "pages_editor.duplicate": "Çoğalt",
  "pages_editor.copy_link": "Blok bağlantısını kopyala",
  "pages_editor.link_copied": "Bağlantı kopyalandı",
  "pages_editor.copy_failed": "Bağlantı kopyalanamadı.",
  "pages_editor.delete": "Sil",
  "pages_editor.strike": "Üstü çizili",
  "pages_editor.inline_code": "Satır içi kod",
  "pages_editor.turn.paragraph": "Metin",
  "pages_editor.turn.heading1": "Başlık 1",
  "pages_editor.turn.heading2": "Başlık 2",
  "pages_editor.turn.heading3": "Başlık 3",
  "pages_editor.turn.bullet": "Madde işaretli liste",
  "pages_editor.turn.numbered": "Numaralı liste",
  "pages_editor.turn.checklist": "Yapılacaklar listesi",
  "pages_editor.turn.toggle": "Aç-kapa",
  "pages_editor.turn.quote": "Alıntı",
  "pages_editor.turn.code": "Kod",
  "pages_editor.group.writing": "Temel bloklar",
  "pages_editor.group.records": "Gerçek kayıtlar",
  "pages_editor.group.media": "Sayfa ve dosyalar",
  "pages_editor.group.tools": "Görünümler ve araçlar",
  "pages_editor.cmd.paragraph": "Metin",
  "pages_editor.cmd.paragraph_hint": "Düz yazı.",
  "pages_editor.cmd.heading1": "Başlık 1",
  "pages_editor.cmd.heading1_hint": "Büyük bölüm başlığı.",
  "pages_editor.cmd.heading2": "Başlık 2",
  "pages_editor.cmd.heading2_hint": "Orta bölüm başlığı.",
  "pages_editor.cmd.heading3": "Başlık 3",
  "pages_editor.cmd.heading3_hint": "Küçük bölüm başlığı.",
  "pages_editor.cmd.bullet": "Madde işaretli liste",
  "pages_editor.cmd.bullet_hint": "Sırasız liste.",
  "pages_editor.cmd.numbered": "Numaralı liste",
  "pages_editor.cmd.numbered_hint": "Sıralı liste.",
  "pages_editor.cmd.checklist": "Yapılacaklar listesi",
  "pages_editor.cmd.checklist_hint": "Bu sayfada kalan onay kutuları.",
  "pages_editor.cmd.toggle": "Aç-kapa",
  "pages_editor.cmd.toggle_hint": "Katlanabilen bölüm.",
  "pages_editor.cmd.quote": "Alıntı",
  "pages_editor.cmd.quote_hint": "Bir bölümü ayrı göster.",
  "pages_editor.cmd.code": "Kod",
  "pages_editor.cmd.code_hint": "Eş aralıklı kod bloğu.",
  "pages_editor.cmd.divider": "Ayraç",
  "pages_editor.cmd.divider_hint": "Bölümler arasına çizgi.",
  "pages_editor.cmd.table": "Tablo",
  "pages_editor.cmd.table_hint": "Basit içerik tablosu.",
  "pages_editor.cmd.columns2": "İki sütun",
  "pages_editor.cmd.columns2_hint": "Blokları yan yana koyun.",
  "pages_editor.cmd.columns3": "Üç sütun",
  "pages_editor.cmd.columns3_hint": "Üç blok yan yana.",
  "pages_editor.cmd.entity_new_hint": "Bu satırda yeni kayıt yazın.",
  "pages_editor.cmd.entity_existing_hint": "Zaten var olan kaydı bulun.",
  "pages_editor.cmd.entity_task": "Yeni görev",
  "pages_editor.cmd.entity_task_existing": "Mevcut görev",
  "pages_editor.cmd.entity_project": "Yeni proje",
  "pages_editor.cmd.entity_project_existing": "Mevcut proje",
  "pages_editor.cmd.entity_plan": "Yeni plan",
  "pages_editor.cmd.entity_plan_existing": "Mevcut plan",
  "pages_editor.cmd.entity_routine": "Yeni rutin",
  "pages_editor.cmd.entity_routine_existing": "Mevcut rutin",
  "pages_editor.cmd.entity_period": "Yeni dönem",
  "pages_editor.cmd.entity_period_existing": "Mevcut dönem",
  "pages_editor.cmd.entity_note": "Yeni not",
  "pages_editor.cmd.entity_note_existing": "Mevcut not",
  "pages_editor.cmd.entity_life_area_existing": "Mevcut yaşam alanı",
  "pages_editor.cmd.entity_life_item_existing": "Mevcut yaşam kaydı",
  "pages_editor.cmd.page": "Sayfa bağlantısı",
  "pages_editor.cmd.page_hint": "Başka bir sayfanızı bağlayın.",
  "pages_editor.cmd.image": "Resim",
  "pages_editor.cmd.image_hint": "Görsel ekleyin.",
  "pages_editor.cmd.file": "Dosya",
  "pages_editor.cmd.file_hint": "Belge ekleyin.",
  "pages_editor.cmd.view": "Görev görünümü",
  "pages_editor.cmd.view_hint": "Canlı sonuçlar, kopya değil.",
  "pages_editor.cmd.calendar": "Takvim",
  "pages_editor.cmd.calendar_hint": "Gerçek programınız, yerinde.",
  "pages_editor.cmd.life_table": "Yaşam tablosu",
  "pages_editor.cmd.life_table_hint": "Takip ettiğiniz bir tabloyu gösterin.",
  "pages_editor.cmd.focus": "Odak sayacı",
  "pages_editor.cmd.focus_hint": "Burada odak seansı başlatın."
}
